var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3526 18.292V28.1306H23.6486V18.9506C23.6486 16.644 22.8233 15.0706 20.7593 15.0706C19.1833 15.0706 18.2446 16.132 17.8326 17.1573C17.682 17.524 17.6433 18.0346 17.6433 18.548V28.1306H11.9366C11.9366 28.1306 12.014 12.584 11.9366 10.972H17.6433V13.404L17.606 13.46H17.6433V13.404C18.4006 12.2373 19.754 10.5693 22.7846 10.5693C26.538 10.5693 29.3526 13.0226 29.3526 18.292ZM5.96864 2.70129C4.01797 2.70129 2.74064 3.98129 2.74064 5.66529C2.74064 7.31196 3.98064 8.63063 5.89398 8.63063H5.93131C7.92198 8.63063 9.15798 7.31196 9.15798 5.66529C9.12331 3.98129 7.92331 2.70129 5.96997 2.70129H5.96864ZM3.07931 28.1306H8.78331V10.972H3.07931V28.1306Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6e1ec5cfce44a441fca74789dc4fb80b.svg";
export { ForwardRef as ReactComponent };